import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InfoBlockStepItem({
  item,
  label
}) {
  var _item$tooltip;
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    tooltip: (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text,
    children: /*#__PURE__*/_jsxs(Text, {
      children: [item.message, item.link && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsx(Link, {
          external: true,
          href: item.link.destination,
          children: item.link.text
        })]
      })]
    })
  });
}